import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=d343f13a&"
import script from "./UploadVideo.vue?vue&type=script&lang=js&"
export * from "./UploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports